export const genesysConfig = {
  production: {
    scriptUrl: 'https://apps.mypurecloud.de/genesys-bootstrap/genesys.min.js',
    environment: 'prod-euc1',
    deploymentId: '5c6e4445-971c-4fe8-9984-f2aa40610284',
  },
  staging: {
    scriptUrl: 'https://apps.mypurecloud.de/genesys-bootstrap/genesys.min.js',
    environment: 'prod-euc1',
    deploymentId: '71d8b2de-c5c4-4607-b8bd-77824e921009',
  },
};
